module.exports = __webpack_public_path__ + "static/screenshot-identity-0ed661690c602416155367cd9d5e23f1.png";